import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import styles from './EditTeamMemberForm.module.css';
import { NavLink , useNavigate} from 'react-router-dom';
import Axios from 'axios';
import Modal from '../../Client/People/ModelPop/Modal';
import GroupForm from '../../Group/GroupForm';
import Companyform from '../../Company/Companyform';
import { Button, Tooltip } from '@mui/material';
import {data} from '../../../../evn/evn'

const initialValues = {
  image: '',
  fullName: '',
  email: '',
  designation: '',
  address: '',
  state: '',
  city: '',
  zipCode: '',
  selectedGroup: '',
  mobileno: '',
};

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required('Full Name is required'),
  email: Yup.string().email('Invalid email format').required('Email is required'),
  designation: Yup.string(),
  address: Yup.string(),
  state: Yup.string(),
  city: Yup.string(),
  zipCode: Yup.string(),
  selectedGroup: Yup.string(),
  mobileno : Yup.string()
  .matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits'),
});

const EditTeamMembersForm = ({teamData, onClose}) => {
  
  const [groupNames, setGroupNames] = useState([]); // State to store group names
  const [formData, setFormData] = useState({});
  const openModalTwo = () => setIsModalOpenTwo(true);
  const [isModalOpenTwo, setIsModalOpenTwo] = useState(false);
  const openModalOne = () => setIsModalOpenOne(true);
  const [isModalOpenOne, setIsModalOpenOne] = useState(false);
  const closeModalTwo = () => setIsModalOpenTwo(false);
  const [companyNames, setCompanyNames] = useState([]);
  const [imagePreview, setImagePreview] = useState('')
  const navigate = useNavigate();
  const ip = data.evn

  const initialValues = {
     image: teamData.image ||'',
    fullName: teamData.fullName || '',
    email: teamData.email || '',
    designation: teamData.designation || '',
    address: teamData.address || '',
    state: teamData.state || '',
    city: teamData.city || '',
    zipCode: teamData.zipCode || '',
    selectedGroup: teamData.selectedGroup || '',
    selectedCompany: teamData.selectedCompany || '',
    mobileno: teamData.mobileno || '',
  };
  
  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required('Full Name is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    designation: Yup.string(),
    address: Yup.string(),
    state: Yup.string(),
    city: Yup.string(),
    zipCode: Yup.string(),
    selectedGroup: Yup.string(),
    selectedCompany: Yup.string(),
    image: Yup.mixed(),
    mobileno : Yup.string()
  .matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits'),
  });

  useEffect(() => {
    if (teamData.image) {
      setImagePreview(`${ip}/uploads/${encodeURIComponent(teamData.image)}`);
    } else {
      setImagePreview(''); // Reset image preview if there's no image
    }
    // Fetch group names and populate the select options
    const fetchGroupNames = async () => {
      try {
        const response = await Axios.get(`${ip}/dashboard/groupform`, {
          headers: {
            'x-auth-token': localStorage.getItem('token'), // Get the token from localStorage or your authentication mechanism
          },
        });

        // Extract the group names from the response data
        const groupNamesArray = response.data.map((group) => group.groupName);
        setGroupNames(groupNamesArray);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchCompanyNames = async () => {
      try {
        const response = await Axios.get(`${ip}/dashboard/company`, {
          headers: {
            'x-auth-token': localStorage.getItem('token'), // Get the token from localStorage or your authentication mechanism
          },
        });
        
        // Extract the group names from the response data
        const companyNamesArray = response.data.map((company) => company.companyName);
        setCompanyNames(companyNamesArray);
      } catch (error) {
        console.error(error);
      }
    };

    Axios.get(`${ip}/dashboard/teammemberform/edit`, {
        headers: {
          'x-auth-token': localStorage.getItem('token'),
        },
      })
      .then((response) => {
        const responseData = response.data[0];
        setFormData(responseData);
        console.log(responseData)
       
      })
      .catch((error) => {
        console.error(error);
      });

    fetchGroupNames(); // Call the fetchGroupNames function when the component mounts
    fetchCompanyNames();
  }, []);

  const HandleCancel=()=>{
    onClose();
  }

  return (
    <div className={styles.MainContainer}>
    <div className={styles.formContainer}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          const formData = new FormData();
          let isImageUploaded = false;
        
          // Append fields to formData
          Object.keys(values).forEach(key => {
            if (key === 'image' && values[key] instanceof File) {
              formData.append('image', values.image);
              isImageUploaded = true;
            } else if (values[key] !== null) {
              formData.append(key, values[key]);
            }
          });
        
          try {
            let imagePath;
            if (isImageUploaded) {
              // If a new image is being uploaded, first upload the image
              const uploadResponse = await Axios.post(`${ip}/upload`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'x-auth-token': localStorage.getItem('token'),
                },
              });
              imagePath = uploadResponse.data.imagePath;
            } else {
              // Use existing image path
              imagePath = values.image;
            }
        
            // Now update the team member data
            const updateData = {
              ...values,
              image: imagePath
            };
        
            const updateResponse = await Axios.put(
              `${ip}/dashboard/teammemberform/edit/update/${teamData.id}`,
              updateData, {
                headers: {
                  'x-auth-token': localStorage.getItem('token'),
                  'Content-Type': 'application/json'
                },
              }
            );
        
            alert('Team Member Updated successfully!');
            resetForm();
            navigate(0);
            // Optionally, navigate or do something else upon success
          } catch (error) {
            if (error.response && error.response.status === 400) {
              alert(error.response.data.error);
            } else {
              console.error(error);
            }
          }
        }}
      >
      
        {({ values, setFieldValue }) => (
          <Form>
              <div className={styles.imageUpload}>
                <label className={styles.imageLabel} htmlFor="image">
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Uploaded"
                      className={styles.uploadedImage}
                    />
                  ) : (
                    <div className={styles.emptyImage}>Click here to Upload</div>
                  )}
                </label>
                <input
                  type="file"
                  id="image"
                  name="image"
                  accept=".png, .jpg, .jpeg"
                  onChange={(event) => {
                    setFieldValue('image', event.currentTarget.files[0]);
                    setImagePreview(URL.createObjectURL(event.currentTarget.files[0]));
                  }}
                  className={styles.imageInput}
                />
                <ErrorMessage name="image" component="div" className={styles.error} />
              </div>



            <div className={styles.fieldGroup}>
              <Field
                type="text"
                name="fullName"
                placeholder="Full Name"
                className={styles.inputField}
              />
              <ErrorMessage name="fullName" component="div" className={styles.error} />
            </div>

            <div className={styles.fieldGroup}>
              <Field type="email" name="email" placeholder="Email" className={styles.inputField} />
              <ErrorMessage name="email" component="div" className={styles.error} />
            </div>
            <div className={styles.fieldGroup}>
              <Field type="text" name="mobileno" placeholder="Mobile Number" className={styles.inputField} />
              <ErrorMessage name="mobileno" component="div" className={styles.error} />
            </div>

            <div className={styles.fieldGroup}>
              <Field
                type="text"
                name="designation"
                placeholder="Designation"
                className={styles.inputField}
              />
            </div>

            <div className={styles.fieldGroup}>
              <Field
                type="text"
                name="address"
                placeholder="Address"
                className={styles.inputField}
              />
            </div>

            <div className={styles.fieldGroup}>
              <Field type="text" name="state" placeholder="State" className={styles.inputField} />
            </div>

            <div className={styles.fieldGroup}>
              <Field type="text" name="city" placeholder="City" className={styles.inputField} />
            </div>

            <div className={styles.fieldGroup}>
              <Field type="text" name="zipCode" placeholder="Zip Code" className={styles.inputField} />
            </div>

            <div className={styles.horizontalFields}>
                <div className={styles.fieldGroup}>
                  <Field as="select" name="selectedGroup" className={styles.selectField}>
                    <option value="">Select a Group</option>
                    {groupNames.map((groupName) => (
                      <option key={groupName} value={groupName}>
                        {groupName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="selectedGroup" component="div" className={styles.error} />
                </div>

              <div className={styles.fieldGroup}>
                <NavLink to={"#"} className={styles.link} onClick={openModalOne}>
                  Add Group
                </NavLink>
              </div>

            </div>
       

            <div className={styles.horizontalFields}>
                <div className={styles.fieldGroup}>
                  <Field as="select" name="selectedCompany" className={styles.selectField}>
                    <option value="">Select a Company</option>
                    {companyNames.map((companyName) => (
                      <option key={companyName} value={companyName}>
                        {companyName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="selectedGroup" component="div" className={styles.error} />
                </div>

              <div className={styles.fieldGroup}>
                <NavLink to={"#"} className={styles.link} onClick={openModalTwo}>
                  Add Company
                </NavLink>
              </div>
            </div>
            <div className={styles.BtnContainer}>
            <Tooltip title="Submit Form">
              <button type="submit" className={styles.submitButton}>SUBMIT</button>
            </Tooltip>
            <Tooltip title="Cancel Form">
              <button  type="submit" onClick={HandleCancel} className={styles.buttonCancel}>CANCEL</button>
            </Tooltip>
            </div>
          </Form>
        )}
      </Formik>

      
    </div>
    <Modal isOpen={isModalOpenOne} onClose={() => setIsModalOpenOne(false)}>
    <GroupForm />
    </Modal>
    
    <Modal isOpen={isModalOpenTwo} onClose={() => setIsModalOpenTwo(false)}>
    <Companyform />
    </Modal>
    </div>
  );
};

export default EditTeamMembersForm;